module.exports = __webpack_public_path__ + "img/check-person.b0f9d3f7.jpg";